import { apolloClient } from "../../vue-apollo";

import { GET_MODULOS_INTRANET, GET_MENU } from "../../graphql/queries";
import {} from "../../graphql/mutations";

export default {
  namespaced: true,
  state: {
    listMenuIntranet: [],
    listMenuDestacado: [],
    listMenuIntranetHash: {},
    menuCliente: [],
  },
  getters: {},
  mutations: {
    /* Acá se agrega la ruta del menu, dado que no viene dentro de ws, la nomclatura es \nombreModulo */
    SET_MODULOS_INTRANET(state, modulos) {
      const moduleHash = {};

      modulos.forEach((modulo) => {
        let ruta = "/";
        let nombre = modulo.moduloGeneral.nombre_modulo
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        let name = nombre.toLowerCase();
        ruta += name;
        modulo.ruta = ruta;
        modulo.id = modulo.id_detalle;
        modulo.notificationCount = 0;
        if (moduleHash[name]) {
          moduleHash[name]++;
          return;
        }
        moduleHash[name] = 1;
      });

      modulos.sort(
        (modA, modB) => modA.posicion_pantalla - modB.posicion_pantalla
      );
      state.listMenuDestacado = modulos.filter((module) => module.destacado).slice(0, 5);

      state.listMenuIntranet = modulos.filter(
        ({ moduloGeneral }) => moduloGeneral.nombre_modulo !== "Inicio"
      );
    },

    SET_MENU_EMPRESA(state, menu) {
      menu.forEach((header) => {
        header.show = false;
        if (header.principal)
          header.principal.forEach((principal) => {
            principal.show = false;
            if (principal.secundarios)
              principal.secundarios.forEach((secundario) => {
                secundario.show = false;
              });
          });
      });

      state.menuCliente = menu;
    },
  },

  actions: {
    async getModulosIntranet({ commit }, data_) {
      const params = {
        query: GET_MODULOS_INTRANET,
        variables: data_,
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.modulosIntranet;
        commit("SET_MODULOS_INTRANET", response);
      } catch (e) {
        console.log("Falla error, getModulosIntranet ", e);
      }
      return response;
    },

    async getMenuEmpresa({ commit }, data_) {
      const params = {
        query: GET_MENU,
        variables: data_,
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.buscarMenu;
        commit("SET_MENU_EMPRESA", response);
      } catch (e) {
        console.log("Falla error, getMenuEmpresa ", e);
      }

      return response;
    },
  },
};
